import script from "./PageDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageDashboard.vue?vue&type=script&lang=ts&setup=true"

import "./PageDashboard.vue?vue&type=style&index=0&id=7bad1612&lang=scss&scoped=true"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bad1612"]])

export default __exports__